<template>
  <div id="se-tab-buyer-console-fcl-container">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div v-show="isEdit">
          <el-button no="1" type="primary" :disabled="selectedContainerUsage === null" @click="changeSealHandler">
            {{ $t('SeaExport.SealNoChangeAdfterInspection') }}
          </el-button>
          <el-button no="2" type="primary" @click="autoLoadHandler">{{ $t('SeaExport.AutoAllocation') }}</el-button>
          <el-button type="primary" @click="autoLoadContractHandler">{{ $t('SeaExport.AutoAllocationContract') }}</el-button>
          <el-button no="3" type="primary" :disabled="selectedContainerUsage === null" @click="autoUnloadHandler">
            {{ $t('SeaExport.CleanOutTheLoadingRecord') }}
          </el-button>
          <el-button
            v-if="!job.lclMasterUuid"
            no="4"
            type="danger"
            :disabled="selectedContainerUsage === null"
            @click="deleteContainerHandler"
          >{{ $t('SeaExport.DeleteTheLoadingRecord') }}
          </el-button>
          <el-button v-if="isFCL" no="5" type="primary" @click="downTemplateBtn_clickHandler">
            {{ $t('SeaExport.TemplateDownload') }}
          </el-button>
          <el-upload
            action="string"
            :http-request="importExcelEventHandler"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUploadUsage"
            style="display: inline-block;padding-left: 5px;"
          >
            <el-button v-if="isFCL" v-show="isEdit" type="primary">{{ $t('SeaExport.ExcelImport') }}</el-button>
            <el-button v-if="toExoSystemJYD && job.masterFlag" :disabled="!(!jydEnable && !isEdit && job.jobState === 0)" no="canPushPreConfiguration" type="primary" @click="toCanPushPreConfiguration">{{ $t('SystemMaintenance.canPushPreConfiguration') }}</el-button>
          </el-upload>
        </div>
        <div>
          <span>
            {{ $t('SeaExport.CargoQuantityDescription') }}：{{ lbTotalDesc.lblContainerDesc }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotalDesc.lbTotalQuantity }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalWeight') }}：{{ lbTotalDesc.lbTotalWeight }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalCubage') }}：{{ lbTotalDesc.lbTotalCubage }}&nbsp;&nbsp;&nbsp;
            <el-button
              v-show="btnshowAWindow && !isEdit"
              no="6"
              type="primary"
              class="can-operate"
              @click="showAWindowClickHandler"
            >{{ $t('SeaExport.ViewAssociatedBusiness') }}</el-button>
          </span>
        </div>
      </div>
    </div>
    <div class="section" style="flex: 1">
      <cargo-ag-grid
        config-module="130115"
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="containerUsages"
        :wrap-text="true"
        style="width:100%;height:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <!-- 查验更改封号弹窗 -->
    <seal-number-change-dialog
      :visible.sync="boxNoDialog.visible"
      :prop-form-data="selectedContainerUsage"
      @sealCloseHandler="sealCloseHandler"
    />
    <!-- 查看关联业务 -->
    <associated-business-dialog
      :visible.sync="associatedBusinessDialog.visible"
      :a-data="associatedBusinessDialog.aData"
      :job="job"
      @refresh="refresh"
    />
  </div>
</template>

<script>
import tabBuyerConsoleFclContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBuyerConsoleFclContainer'

export default {
  name: 'SeTabBuyerConsoleFclContainer',
  extends: tabBuyerConsoleFclContainer,
  props: {
    containerConfig: { type: Object, default: () => { } }
  }
}
</script>
